import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { MyAccountState, StateWithMyAccount } from '../my-account-state';
import { getMyAccountState } from './state.selectors';

export const approveManager: MemoizedSelector<
  StateWithMyAccount,
  StateUtils.EntityLoaderState<string>
> = createSelector(getMyAccountState, (state: MyAccountState) => state.approveManager);

export const approveManagerLoading = (personalManagerId: string): MemoizedSelector<StateWithMyAccount, boolean> =>
  createSelector(approveManager, (state: StateUtils.EntityLoaderState<string>) =>
    StateUtils.entityLoadingSelector(state, personalManagerId),
  );

export const approveManagerError = (personalManagerId: string): MemoizedSelector<StateWithMyAccount, boolean> =>
  createSelector(approveManager, (state: StateUtils.EntityLoaderState<string>) =>
    StateUtils.entityErrorSelector(state, personalManagerId),
  );

export const approveManagerSuccess = (personalManagerId: string): MemoizedSelector<StateWithMyAccount, boolean> =>
  createSelector(approveManager, (state: StateUtils.EntityLoaderState<string>) =>
    StateUtils.entitySuccessSelector(state, personalManagerId),
  );
